import HttpServices from './HttpServices';
import { DatavizualizationSettings,} from '../Auth/Insights/context/TypeDataviz';

const devOnly = 'devonly/';
// bergere '5c4cfe50-0d91-4af3-bf15-1e1f1c2ae505' // multi tenant
// Berceau m 'f20e8166-8f25-422f-ba07-4ff093a7cde2'
// total '7c7a1786-e0bf-47c5-a41d-64ed99b59a47'
// perle d467d981-b1b3-4484-bf4b-e9017f8e09a2
// veo 90cbfab9-f76f-458b-bccd-366a9031a795
// Carrefour voyage  95e7c953-b2b9-4b38-a917-18fe9c52bce9
// carrefour 74009ef3-da03-471e-91ae-d10c64b5178f
// alice 9050bb90-d708-4287-8034-cca045a148f1
// showroom 2 b04d7f9b-6dd2-459b-9a0f-52d2877939f2
const idForDevOnly = '95e7c953-b2b9-4b38-a917-18fe9c52bce9'; 
export default class DataviluazizationServices {
	HttpServices: HttpServices;
	BO_API_URL: string;
	accountId: string;
	useDevonly: boolean;
	constructor(accountId: string, $http: any) {
		this.HttpServices = new HttpServices($http);
		if (!window || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw 'Configuration [window.BEYABLE_env.BO_API_URL] missing';
		} else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}
		this.accountId = accountId;
		this.useDevonly = false;
	}

	
	getAggregatedVisitorJourney(payload:DatavizualizationSettings, callbackSuccess, callbackError) {
		this.HttpServices.post(`${this.BO_API_URL}${this.useDevonly ? devOnly : ''}${this.useDevonly ? idForDevOnly : this.accountId}/aggregated-visitor-journeys/`, payload,callbackSuccess, callbackError);
	}

	getLimitAggregatedVisitorJourneyForAccount(callbackSuccess, callbackError){
		this.HttpServices.get(`${this.BO_API_URL}${this.useDevonly ? devOnly : ''}${this.useDevonly ? idForDevOnly : this.accountId}/aggregated-visitor-journeys/request-bounds`,callbackSuccess, callbackError);
	}
	getTenantScore(callbackSuccess, callbackError){
		this.HttpServices.get(`${this.BO_API_URL}${this.useDevonly ? devOnly : ''}${this.useDevonly ? idForDevOnly : this.accountId}/account-tenants/score-tenants`,callbackSuccess,callbackError);
	}

}